var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicStick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "rgb(100, 116, 139)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-wand-sparkles h-6 w-6 text-muted-foreground",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14 7 3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2v2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16h-4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicStick);
export default __webpack_public_path__ + "static/media/magic-stick.508d6d7c9164340fe4467bf20cb043b7.svg";
export { ForwardRef as ReactComponent };